export default "__VITE_ASSET__Dux5Q1kK__"